import { createSelector } from 'reselect';
import RedirectTo from '../../Common/RedirectTo';
import { getEntities } from '../../../Resources/EntityData';
import { bookDemoSchema, BOOK_DEMO_ACTIONS } from './BookDemoSchema';
import ProgressiveApi from './ProgressiveApi';
import { EmptyObject } from '../../../Resources/EmptyDefaults';

export const LOCAL_STORAGE_DEMO_BOOKED = 'demoBooked';

export const SCHEDULING = 'scheduling';
export const INVOICING = 'invoicing';
export const ONLINE_BOOKING = 'online_booking';
export const CREDIT_CARD_PAYMENTS = 'credit_card_payments';
export const DISPATCHING = 'dispatching';
export const ESTIMATES = 'estimates';
export const MORE_CUSTOMERS = 'more_customers';

export const featureInterests = [
  {
    title: 'Schedule & dispatch jobs',
    buttonName: 'schedule and dispatch jobs',
    body: 'Add jobs, assign them to your techs, send notifications —keeping everyone up-to-date.',
    redirectToLink: RedirectTo.scheduleAndDispatch,
    value: [SCHEDULING, DISPATCHING],
  },
  {
    title: 'Send paperless invoices',
    buttonName: 'setup paperless invoices',
    body: 'Create professional invoices and send them via email or text.  Get paid online.',
    redirectToLink: RedirectTo.sendInvoices,
    value: [INVOICING],
  },
  {
    title: 'Setup 1-click estimates',
    buttonName: 'setup 1-click estimates',
    body: 'Send estimates via email or sms to your customers and get online approval.',
    redirectToLink: RedirectTo.estimatesFirstTimeUse,
    value: [ESTIMATES],
  },
  {
    title: 'Get more reviews',
    buttonName: 'get more reviews',
    body: 'Collect reviews automatically and boost your online presence.',
    redirectToLink: RedirectTo.getReviews,
    value: [MORE_CUSTOMERS],
  },
];

export const getProgressiveSettings = createSelector(
  getEntities,
  (entities) => entities?.[BOOK_DEMO_ACTIONS]?.['data'] || EmptyObject
);

export const canBookDemo = createSelector(getProgressiveSettings, (settings) => settings.can_book_demo);

export const fetchCanBookDemo = {
  fetchingApiFunc: ProgressiveApi.canBookDemo,
  selector: getProgressiveSettings,
  paramsFromProps: () => [],
  schema: bookDemoSchema,
};

export const demoTime = createSelector(getProgressiveSettings, (settings) => settings.demo_time || false);

export const alreadyBookedDemo = createSelector(getProgressiveSettings, (settings) => settings.already_booked_demo);
